import { Card, CardContent, IconButton, Popover } from "@mui/material";
import { useState, useEffect, useCallback, useMemo } from "react";
import CheckCircleOutlineOutlinedIcon from "@mui/icons-material/CheckCircleOutlineOutlined";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import NotificationLogo from "../../assets/icons/notification.svg";
import { ToastHelper } from "../../utils/toastHelper";
import { notificationData } from "./notificationService";
import useIsMobile from "../../hooks/useIsMobile.hook";

const Notification = () => {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const [notificationListData, setNotificationListData] = useState<any[]>([]);
  const toastHelper = useMemo(() => new ToastHelper(), []);
  const isMobile = useIsMobile();

  const fetchNotifications = useCallback(async () => {
    try {
      const data = await notificationData();
      setNotificationListData(data);
    } catch (error) {
      console.error(error);
      toastHelper.showToast({
        severity: "error",
        content: "Notifications failed due to server error. Please try again.",
      });
    }
  }, [toastHelper]);

  useEffect(() => {
    fetchNotifications();
  }, [fetchNotifications]);

  const isOpen = Boolean(anchorEl);
  const id = isOpen ? "simple-popover" : undefined;

  const handleNotification = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
    void fetchNotifications();
  };

  const handleNotificationClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <IconButton
        className="headerNotification"
        title="Notifications"
        onClick={handleNotification}
        aria-label="Notifications"
      >
        <img className="iconSize" src={NotificationLogo} alt="Notification" />
        {notificationListData && notificationListData.length > 0 ? (
          <div className="notificationAlert"></div>
        ) : (
          <></>
        )}
      </IconButton>
      <div className="notificationBox">
        {anchorEl && (
          <div>
            <Popover
              id={id}
              open={isOpen}
              anchorEl={anchorEl}
              onClose={handleNotificationClose}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "left",
              }}
              PaperProps={{
                style: {
                  width: "408px",
                  boxShadow: "0px 2px 4px -2px #4747473D",
                  marginTop: "1em",
                  maxHeight: "calc(100vh - 125px)",
                  overflowY: "auto",
                  marginLeft: isMobile ? 0 : "-5em",
                  borderRadius: "8px",
                },
              }}
            >
              <div>
                <Card sx={{ minWidth: 275 }}>
                  <CardContent>
                    <div className="notificationStatus">
                      <div className="notificationCount">
                        {notificationListData?.length
                          ? notificationListData?.length
                          : "No"}{" "}
                        new notification
                      </div>
                    </div>
                    <div className="boxMaxHeight">
                      {notificationListData &&
                      notificationListData.length > 0 ? (
                        notificationListData.map((data: any, index: any) => {
                          return (
                            <div key={index} className="notificationInfoBox">
                              {data.acknowledged === false ? (
                                <div className="container">
                                  <div className="leftSection">
                                    <InfoOutlinedIcon className="acknowledgeIconSize" />
                                  </div>
                                  <div className="rightSection">
                                    <div className="notificationText">
                                      {data.ts_id}{" "}
                                      <span className="notificationConetnt">
                                        has been submitted for acknowledgment
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              ) : (
                                <div className="container">
                                  <div className="leftSection">
                                    <CheckCircleOutlineOutlinedIcon className="acknowledgeIconSize" />
                                  </div>
                                  <div className="rightSection">
                                    <div className="notificationText">
                                      {data.ts_id}{" "}
                                      <span className="notificationConetnt">
                                        has been acknowledged
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              )}
                            </div>
                          );
                        })
                      ) : (
                        <div className="noNotificationInfoBox">
                          No new notification
                        </div>
                      )}
                    </div>
                  </CardContent>
                </Card>
              </div>
            </Popover>
          </div>
        )}
      </div>
    </>
  );
};

export default Notification;
